import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { samplePages } from '../data/samplePages';
import { SectionHeading } from './SectionHeading';
import { SemesterGrid } from './SemesterGrid';
export function SamplePages() {
  const [index, setIndex] = useState(0);
  const total = samplePages.length;
  const page = samplePages[index];
  const go = (step: number) => setIndex(current => (current + step + total) % total);
  return <section aria-labelledby="samples-heading" className="bg-ink py-16 sm:py-24" data-id="element-156" data-mp="1i21x9ki0d42b">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-157" data-mp="1w2uw2hfcelb8">
        <SectionHeading id="samples-heading" intro="Prawdziwe strony z pakietu — ćwiczenia, tabulatury i chwyty gotowe do druku." data-id="element-158" data-mp="1w08ncegptzrf">
          Tak wygląda <span className="text-gold" data-id="element-159" data-mp="1p3lnfp6vxeq">każda strona</span>
        </SectionHeading>

        <div className="mx-auto mt-10 max-w-3xl sm:mt-12" aria-roledescription="karuzela" data-id="element-160" data-mp="3sw6fkewewhsn">
          <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-card shadow-card-dark" data-id="element-161" data-mp="10lnwynm51llf">
            <AnimatePresence mode="wait" initial={false} data-id="element-162" data-mp="15k7lmvs49bhh">
              <motion.figure key={index} initial={{
              opacity: 0,
              x: 16
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -16
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-163" data-mp="1ai93xehpx6rw">
                <div className="flex aspect-[4/3] w-full items-center justify-center bg-[#FCFBF7] p-2 sm:p-4" data-id="element-164" data-mp="1oa795e8b6iis">
                  <img src={page.image} alt={`Strona z pakietu: ${page.title}`} className="max-h-full max-w-full object-contain" data-id="element-165" data-mp="1t8qupdizpsam" />
                </div>
                <figcaption className="border-t border-white/10 p-5" data-id="element-166" data-mp="1y7llp2r42n5t">
                  <p className="font-display text-xl font-extrabold leading-tight text-white" data-id="element-167" data-mp="3v1ortljsv71d">{page.title}</p>
                  <p className="mt-1 text-sm text-copy-light" data-id="element-168" data-mp="3v5arondekum">{page.caption}</p>
                </figcaption>
              </motion.figure>
            </AnimatePresence>
          </div>
          <div className="mt-5 flex items-center justify-between" data-id="element-169" data-mp="3n10nhffsfv3o">
            <button type="button" onClick={() => go(-1)} aria-label="Poprzednia strona" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-170" data-mp="5ru1z0a4brk6">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-171" data-mp="9se3sh5mzjcn" />
            </button>
            <div className="flex items-center gap-3" data-id="element-172" data-mp="oildo8hkvu1q">
              <span className="font-display text-lg font-bold tabular-nums text-white" data-id="element-173" data-mp="ok63xlwv0qts">
                {String(index + 1).padStart(2, '0')} / {String(total).padStart(2, '0')}
              </span>
              <div className="flex gap-1.5" data-id="element-174" data-mp="xgnhswwlz2t8">
                {samplePages.map((sample, dotIndex) => <button key={sample.title} type="button" onClick={() => setIndex(dotIndex)} aria-label={`Strona ${dotIndex + 1}`} aria-current={dotIndex === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-out ${dotIndex === index ? 'w-6 bg-gold' : 'w-2 bg-white/30'}`} data-id="element-175" data-mp="tflk4kicaytd" data-mpi={dotIndex} />)}
              </div>
            </div>
            <button type="button" onClick={() => go(1)} aria-label="Następna strona" className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-176" data-mp="y6pj6sn68js4">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-177" data-mp="aig2240wkk7b" />
            </button>
          </div>
        </div>

        <div className="mx-auto mt-16 max-w-5xl sm:mt-20" data-id="element-178" data-mp="1hsuj6xq21l8r">
          <div className="mb-6 text-center" data-id="element-179" data-mp="1hsci9nsg6iui">
            <h3 className="font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-180" data-mp="1dritytb3f213">
              Plan na 16 tygodni <span className="text-gold" data-id="element-181" data-mp="18zr2mgk44s9w">w 3 ścieżkach</span>
            </h3>
            <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-copy-light sm:text-base" data-id="element-182" data-mp="141pehh7ty2rk">
              Każdy tydzień ma ten sam temat dla wszystkich uczniów — każdy przerabia go na swoim poziomie.
            </p>
          </div>
          <SemesterGrid data-id="element-183" data-mp="u1q7vpuz0mhc" />
        </div>
      </div>
    </section>;
}